import { $_app_server } from '@/_helpers'

export const letterService = {
    list,
    getEnvelopeFormats,
    letter,
    letters,
    updateEnvelopeFormat,
    getMailType,
    requestBarCode,
    setToRegistry,
    remove,
    update,
    newLetter,
    uvedomlenie

}

function list () {
    return $_app_server.cacheGet("letters").then(response => response.data)
}

function getEnvelopeFormats () {
    return $_app_server.get("envelopeformats").then(response => response.data)
}

function getMailType () {
    return $_app_server.get("mailtypes").then(response => response.data)
}

// Unneeded
function letter (id) {
    return $_app_server.get("letters/" + id).then(response => response.data)
}

function newLetter (letter) {
    return $_app_server.put("letter/new", letter).then(response => response.data)
}


// Deprecate
function letters (ids) {
    return $_app_server.patch("letters", ids).then(response => response.data)
}

// Deprecate
function updateEnvelopeFormat (mLetter) {
    return $_app_server.patch("letters/" + mLetter.current.id, {weight: mLetter.weight.value, envelopeFormat: mLetter.format.value})
    .then(response => response.data)
}

function update (letter) {
    return $_app_server.put("letters", letter).then(response => response.data)
}

function requestBarCode (id) {
    return $_app_server.patch("letters/" + id + "/request").then(response => response.data)
}

function uvedomlenie (id) {
    return $_app_server.patch("letters/" + id + "/uvedomlenie").then(response => response.data)
}

function setToRegistry (id) {
    return $_app_server.patch("letters/" + id + "/print").then(response => response.data)
}

function remove (id) {
    return $_app_server.delete("letters/" + id).then(response => response.data)
}